import { FETCH_BANKS, SET_REDIRECT } from './types';

const initialState = {
    redirect: false,
    banks: []
};

export function ZwalletTransferReducer(state=initialState, action) {
  let payload;
  switch(action.type) {
    case FETCH_BANKS:
      payload = action.payload;

      return {
        ...state,
        banks: [...payload]
      }

    case SET_REDIRECT:
      payload = action.payload;

      return {
        ...state,
        redirect: payload
      }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/reducer.js